import { ref } from '../../config/constants'
import {
  FETCH_ACCOUNT,
  DELETE_ACCOUNT,
  FETCH_ACCOUNTS,
} from './types';

const Accounts = ref.child("accounts");

export function updateUserInfo(user, account) {
  return dispatch => user.updateUserInfo(account);
}


export function updateAccount(uid, account) {
  return dispatch => Accounts.child(uid).set(account);
}

export function createAccount(account) {
  return dispatch => Accounts.push(account);
}


export function deleteAccount(key) {
  return dispatch => {
    Accounts.child(key).remove()
      .then(() => {
        dispatch({
          type: DELETE_ACCOUNT,
          payload: key
        })
      })
    }
}

export function fetchAccount(key) {
  return dispatch => {
    Accounts.child(key).on('value', snapshot => {
      if (snapshot.val() == null)
      {
        dispatch( updateAccount(key, {name: ""}) );        
      }
      dispatch({
        type: FETCH_ACCOUNT,
        payload: snapshot.val()
      });
    });
  };
};

export function fetchAccounts() {
  return dispatch => {
    Accounts.on('value', snapshot => {
      dispatch({
        type: FETCH_ACCOUNTS,
        payload: snapshot.val()
      });
    });
  };
};




// WEBPACK FOOTER //
// ./src/data/accounts/actions.js